import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.join.js";
import Head from "@/components/Head/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import UpLoadImg from "@/components/UpLoadImg/index.vue";
import { validStEnpty } from "@/hooks/validate";
import { defineComponent, reactive, ref, toRefs } from "vue";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  components: {
    Head: Head,
    UpLoadImg: UpLoadImg
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var route = useRoute();
    var router = useRouter();
    var mailboxId = route.query.mailboxId;
    var uploadRef = ref(null); //图片

    var files = [];

    function filechange(val) {
      files = val;
    } //表单验证


    var ruleForm = reactive({
      content: ""
    });

    var contentPass = function contentPass(rule, value, callback) {
      if (!validStEnpty(ruleForm.content)) {
        callback(new Error("请输入内容"));
      } else {
        callback();
      }
    };

    var rules = {
      content: [{
        required: true,
        validator: contentPass,
        trigger: 'blur'
      }]
    };
    var ruleForms = ref(null); //写信

    function submitForm() {
      ruleForms.value && ruleForms.value["validate"]( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var obj, _yield$globalProperti, code;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!valid) {
                    _context.next = 8;
                    break;
                  }

                  obj = {};
                  obj = {
                    mailboxId: mailboxId,
                    replyContent: ruleForm.content,
                    img: files.join(",")
                  };
                  _context.next = 5;
                  return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["replyEmail"](_objectSpread({}, obj));

                case 5:
                  _yield$globalProperti = _context.sent;
                  code = _yield$globalProperti.code;

                  if (code == 0) {
                    ElMessage.success("操作成功");
                    setTimeout(function () {
                      router.back();
                    }, 300);
                  } else {
                    ElMessage.error("操作失败");
                  }

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }

    return _objectSpread(_objectSpread({
      route: route,
      ruleForm: ruleForm,
      rules: rules,
      ruleForms: ruleForms
    }, toRefs(ruleForm)), {}, {
      submitForm: submitForm,
      files: files,
      uploadRef: uploadRef,
      filechange: filechange,
      contentPass: contentPass
    });
  }
});